<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import Widget from './widget'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '360MDR Real Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data () {
    return {
      dashboard: {
        'widgets': [
          {
            'source': '/pan/xdr/count/timerange/datetime?minutes=1440&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident&match=incident.incident.severity,high',
            'id': 'info2',
            'name': 'incidentes MDR de severidad alta ultimas 24h',
            'cols': 'col-md-2',
            'class': 'severity_high',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'trend': true
          },
          {
            'source': '/pan/xdr/count/timerange/datetime?minutes=1440&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident',
            'id': 'info1',
            'name': 'incidentes MDR en las ultimas 24h',
            'cols': 'col-md-2',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'trend': true
          },
          {
            'source': '/pan/xdr/add/timerange/datetime?minutes=1440&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident.alert_count&match=incident.alerts.data.severity,high',
            'id': 'info3',
            'name': 'Alertas MDR de severidad alta ultimas 24h',
            'cols': 'col-md-2',
            'class': 'severity_high',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'trend': true
          },
          {
            'source': '/pan/xdr/add/timerange/datetime?minutes=1440&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident.alert_count',
            'id': 'info4',
            'name': 'Alertas MDR en las ultimas 24h',
            'cols': 'col-md-2',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'trend': true
          },
          {
            'source': '/pan/xdr/agg/date/day?collection=cortex_incidents&variable=incident.incident.creation_time&limit=10&match=incident.incident.severity,high',
            'id': 'info2',
            'name': 'incidentes de MDR alta en lo que va de hoy (GMT)',
            'cols': 'col-md-2',
            'class': 'severity_high',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/date/day?collection=cortex_incidents&variable=incident.incident.creation_time&limit=2',
            'id': 'info1',
            'name': 'incidentes MDR en lo que va de hoy (GMT)',
            'cols': 'col-md-2',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000
          },
          {
            'id': 'widget1',
            'name': 'TOP DE INCIDENTES MDR POR GEOGRAFIA ULTIMAS 24H',
            'source': '/pan/xdr/countries/top',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'worldmap',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.status&outvars=label&tvariable=incident.incident.modification_time&minutes=1440&limit=6',
            'id': 'widget2',
            'name': 'ACCIONES / EVENTOS MDR ULTIMAS 24H',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dpie',
            'type': 'radialBar',
            'colors': ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/incidents/top?maxlength=100',
            'name': 'ULTIMOS INCIDENTES MDR',
            'cols': 'col-md-12',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'refresh': 60000
          },
          {
            'name': 'INCIDENTES MDR',
            'series': [
              {
                'name': 'Incidentes Cortex',
                'type': 'column',
                'source': '/pan/xdr/agg/date/month?collection=cortex_incidents&variable=incident.incident.creation_time&start=0',
                'labelsSource': true,
                'color': '#0084FF'
              },
              {
                'name': 'Severidad Alta',
                'type': 'line',
                'source': '/pan/xdr/agg/date/month?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,high&start=0',
                'color': '#DC001E'
              },
              {
                'name': 'Severidad Media',
                'type': 'line',
                'source': '/pan/xdr/agg/date/month?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,medium&start=0',
                'color': '#FECA00'
              },
              {
                'name': 'Severidad Baja',
                'type': 'line',
                'source': '/pan/xdr/agg/date/month?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,low&start=0',
                'color': '#01AD00'
              }
            ],
            'cols': 'col-md-12',
            'height_class': 'tall_widget',
            'cardStyle': 'height:360px;',
            'component': 'mixed',
            'refresh': 60000
          },
          {
            'name': 'SESIONES AGREGADAS POR ACCIÓN EN NGFWs PALOALTO NETWORKS',
            'series': [
              {
                'name': 'Negadas',
                'type': 'line',
                'labelsSource': true,
                'source': '/pan/xdr/agg/date/day?collection=pan_ngfw_traffic_stats&variable=datetime&action=sum&sumvar=result.denied&start=0',
                'color': '#DC001E'
              },
              {
                'name': 'Permitidas',
                'type': 'line',
                'source': '/pan/xdr/agg/date/day?collection=pan_ngfw_traffic_stats&variable=datetime&action=sum&sumvar=result.allowed&start=0',
                'color': '#01AD00'
              }
            ],
            'cols': 'col-md-12',
            'height_class': 'tall_widget',
            'cardStyle': 'height:360px;',
            'component': 'mixed',
            'refresh': 60000
          },
          // {
          //   'name': 'INCIDENTES NUEVOS CORTEX',
          //   'series': [
          //     {
          //       'name': 'Incidentes Nuevos Cortex',
          //       'type': 'column',
          //       'source': '/pan/xdr/incidents/stats?base=no',
          //       'labelsSource': true,
          //       'color': '#0084FF'
          //     }
          //   ],
          //   'cols': 'col-md-12',
          //   'height_class': 'tall_widget',
          //   'cardStyle': 'height:360px;',
          //   'component': 'mixed',
          //   'refresh': 60000
          // },
          {
            'name': 'ALARMAS OFFICE 365',
            'series': [
              {
                'name': 'Alarmas Office 365',
                'type': 'column',
                'source': '/pan/xdr/agg/date/month?collection=azure_events_alarms&variable=start&start=0',
                'labelsSource': true,
                'color': '#0084FF'
              }
              // {
              //   "name": "Severidad Alta",
              //   "type": "line",
              //   "source": "/pan/xdr/agg/date/month?collection=azure_events_alarms&variable=start&match=severity,high&start=0",
              //   "color": "#DC001E"
              // },
              // {
              //   "name": "Severidad Media",
              //   "type": "line",
              //   "source": "/pan/xdr/agg/date/month?collection=azure_events_alarms&variable=start&match=severity,medium&start=0",
              //   "color": "#FECA00"
              // },
              // {
              //   "name": "Severidad Baja",
              //   "type": "line",
              //   "source": "/pan/xdr/agg/date/month?collection=azure_events_alarms&variable=start&match=severity,low&start=0",
              //   "color": "#01AD00"
              // },
            ],
            'cols': 'col-md-12',
            'height_class': 'tall_widget',
            'cardStyle': 'height:360px;',
            'component': 'mixed',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.category&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&minutes=1440&uw=incident.alerts.data&limit=10&tkind=timestamp',
            'name': 'TIPOS DE ALERTAS MDR ULTIMAS 24H',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.action_pretty&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&minutes=1440&uw=incident.alerts.data&limit=10&tkind=timestamp&maxlength=55',
            'name': 'TIPOS DE ACCIONES MDR ULTIMAS 24H',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.host_ip',
            'name': 'TOP DE HOSTS EN ALERTAS MDR ULTIMAS 24H',
            'cols': 'col-md-4',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.name&maxlength=100',
            'name': 'TOP DE ALERTAS MDR EN LAS ÚLTIMAS 24H',
            'cols': 'col-md-8',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'refresh': 60000
          }
        ]
      },
      // jsonDef: '@src/router/views/pages/dashboard/data/'+name,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  computed: {

  },
  mounted () {

    // console.log(this.jsonDef)
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="row">
        <template v-for="(widget, index) in dashboard.widgets">
          <!-- <div :class="widget.cols">
						<span><h5>{{ widget.name }}</h5></span>
						<b-card no-body class="text-center" style="line-height:300px">
							{{ widget.component }}
						</b-card>
					</div> -->
          <Widget
            :key="index"
            :title="widget.name"
            :component="widget.component"
            :source="widget.source"
            :series="widget.series"
            :cols="widget.cols"
            :trend="widget.trend"
            :wclass="widget.class"
            :type="widget.type"
            :card-style="widget.cardStyle"
            :categories="widget.categories"
            :colors="widget.colors"
            :colors-by-label="widget.colorsByLabel"
            :range="widget.range"
            :start="startEpoch"
            :end="endEpoch"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>
